import React from 'react';

import { Button } from '@infoods/lifebase-ui';

import { GridTableCell } from '../../../../../shared/components/table-components';
import { YoutubeVideoModal } from '../../../../../shared/components/modals';
import { openModal } from '../../../../../shared/utils/reactUtils/openModal/openModal';
import { ReleaseInfo } from '../../../../interfaces/ReleaseInfo';

type ReleaseVideoCellProps = Pick<ReleaseInfo, 'videoLink'>;

const ReleaseVideoCell = ({ videoLink }: ReleaseVideoCellProps) => {
  const handleOpenVideoClick = () => {
    openModal((closeModal) => (
      <YoutubeVideoModal open onClose={closeModal} videoSrc={videoLink} />
    ));
  };

  return (
    <GridTableCell justify="end">
      {videoLink ? (
        <Button variant="fileLink" onClick={handleOpenVideoClick}>
          Open video here &gt;
        </Button>
      ) : (
        <span>No video</span>
      )}
    </GridTableCell>
  );
};

export { ReleaseVideoCell };
